import React from 'react';
import { IPageSectionEntry } from '../../../../contentful';
import { SectionComponent } from '../SectionComponent';

interface ISectionListProps {
	sections?: IPageSectionEntry[];
}

export const SectionList = ({ sections }: ISectionListProps) => (
	<>
		{sections?.map((section: IPageSectionEntry) => (
			<SectionComponent key={section.id} section={section} />
		))}
	</>
);
